import instance from 'utils/axiosConfig';

/**
 * 기기 목록 조회 API
 * @param {Object} [params] - 쿼리 파라미터
 * @returns {Promise} API 응답 - 기기 목록
 */
export const getDeviceList = async (params) => {
    try {
        const response = await instance.get('/api/v1/device/item', { params });
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * 기기 상세 조회 API
 * @param {Object} [deviceId] - 기기 ID
 * @returns {Promise} API 응답 - 기기 상세 정보
 */
export const getDeviceDetail = async (deviceId) => {
    try {
        const response = await instance.get(`/api/v1/device/item/${deviceId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * 라이선스 조회 API
 * @returns {Promise} API 응답 - 라이선스 상세 정보
 */
export const getLicenseDetail = async () => {
    try {
        const response = await instance.get(`/api/v1/device/license`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getActAccountDetail = async () => {
    try {
        const response = await instance.get(`/api/v1/device/act`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
